import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import API_ENDPOINTS from '../../config/apiConfig';
import { useData } from '../../context/DataContext';
import { fetchFromApi } from '../../config/api';

function AddArtistModel(props) {
    const { fetchArtistData } = useData();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [artistData, setArtistData] = useState({
        name: '', email: '', mobile: '', address: '', about: '', image: ''
    });

    const handleChange = (e) => {
        setArtistData({ ...artistData, [e.target.name]: e.target.value });
        setError("");
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => setArtistData((prev) => ({ ...prev, image: reader.result }));
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!artistData.name || !artistData.email || !/\S+@\S+\.\S+/.test(artistData.email)) {
            setError("Please fill all required fields with valid information.");
            return;
        }
        if (artistData.mobile && artistData.mobile.length !== 10) {
            setError("Please enter a valid 10-digit mobile number.");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const data = await fetchFromApi(API_ENDPOINTS.ADD_ARTIST, 'POST', artistData);
            if (data.status === "success") {
                setSuccessMsg("Artist added successfully!");
                setTimeout(async () => { setSuccessMsg(""); props.onHide(); await fetchArtistData(); }, 1500);
            } else {
                setError("Failed to add artist. Please try again.");
            }
        } catch {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Artist</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="modal-form-grid">
                        <div className="form-field">
                            <label>Name <span className="req">*</span></label>
                            <input type="text" name="name" value={artistData.name} onChange={handleChange} placeholder="Full name" />
                        </div>
                        <div className="form-field">
                            <label>Email <span className="req">*</span></label>
                            <input type="email" name="email" value={artistData.email} onChange={handleChange} placeholder="artist@example.com" />
                        </div>
                        <div className="form-field">
                            <label>Mobile</label>
                            <input type="tel" name="mobile" value={artistData.mobile} onChange={handleChange}
                                maxLength={10} placeholder="10-digit number"
                                onKeyPress={(e) => { if (!/^\d$/.test(e.key)) e.preventDefault(); }} />
                        </div>
                        <div className="form-field">
                            <label>Address</label>
                            <input type="text" name="address" value={artistData.address} onChange={handleChange} placeholder="City, State" />
                        </div>
                    </div>

                    <div className="modal-form-grid cols-1">
                        <div className="form-field">
                            <label>About Artist</label>
                            <textarea name="about" value={artistData.about} onChange={handleChange} rows={4} placeholder="Short bio…" />
                        </div>
                    </div>

                    <div className="form-field">
                        <label>Profile Image</label>
                        <input type="file" accept="image/*" onChange={handleImageChange} />
                        {artistData.image && (
                            <div className="img-preview-wrap">
                                <img src={artistData.image} alt="Preview" />
                                <button type="button" className="img-remove-btn"
                                    onClick={() => setArtistData((p) => ({ ...p, image: '' }))}>×</button>
                            </div>
                        )}
                    </div>

                    {error && <div className="modal-alert error"><i className="fa-solid fa-circle-exclamation"></i> {error}</div>}
                    {successMsg && <div className="modal-alert success"><i className="fa-solid fa-circle-check"></i> {successMsg}</div>}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn-primary-orange" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Adding…" : "Add Artist"}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddArtistModel;
